import { EditorConfig, EditorThemeClasses } from 'lexical';

export enum WTColor {
  Gray = 'gray',
}
export type WTEditorThemeClasses = EditorThemeClasses & {
  colors: Record<WTColor, string>;
};
export type WTEditorConfig = Omit<EditorConfig, 'theme'> & {
  theme: WTEditorThemeClasses;
};

export enum BlockType {
  Heading1 = 'h1',
  Heading2 = 'h2',
  Heading3 = 'h3',
  Paragraph = 'paragraph',
  Bullet = 'bullet',
  Number = 'number',
  Check = 'check',
  Quote = 'quote',
}
